exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vgs .rotate-ccw,.vgs .rotate-cw{position:absolute;top:20px}.vgs .rotate-cw{right:20px}.vgs .rotate-ccw{left:20px}", ""]);

// exports
